import React from 'react'
import { Modal } from 'components/UIElements'
import { BLOCKING_CONSENT_MODAL_TEXT } from 'utils/constants'
import { navigateTo } from 'navigation'

export default function BlockingConsentModal(props) {
  const { showConsentModal, strings } = props
  const onConfirm = () => {
    navigateTo('/consent')
  }
  return (
    showConsentModal && (
      <Modal
        heading={
          strings.consent_required ??
          BLOCKING_CONSENT_MODAL_TEXT.consentRequired
        }
        content={
          strings.please_complete_consent ??
          BLOCKING_CONSENT_MODAL_TEXT.pleaseCompleteConsent
        }
        open={showConsentModal}
        noCancel={true}
        humi={true}
        className='blocking-consent'
        onConfirm={onConfirm}
      />
    )
  )
}
